import { useEffect, useState } from 'react';
import { Ikon } from '../status/Ikon.tsx';
import { lesValg, skrivValg, start, type Temavalg } from './tema.ts';

const VALG: ReadonlyArray<{ verdi: Temavalg; navn: string }> = [
  { verdi: 'auto', navn: 'System' },
  { verdi: 'light', navn: 'Lys' },
  { verdi: 'dark', navn: 'Mørk' },
];

/**
 * Palettvelgeren, som fra R4.3 bor i menyen «⋯» (M2.6, DD-48 presisert). Tre knapper i en
 * `radiogroup` — ikke en av/på-bryter, fordi `auto` er en tredje tilstand og ikke «av».
 *
 * Ikonet er GRUPPENS, ikke segmentenes: hvert segment hadde sitt eget (kontrast, sol,
 * måne), og tre ikoner til i en meny på 216 px er dekor — ordet bærer meningen, som
 * ellers i panelet. Det valgte segmentet bærer et hakemerke i tillegg til flaten, så
 * tilstanden er ikon og form og ikke farge alene (DD-08-presiseringen 2026-09-19).
 */
export function Temavelger() {
  const [valg, setValg] = useState<Temavalg>(() => lesValg());

  useEffect(() => start(valg), [valg]);

  return (
    <div className="panel-tema">
      {/* Etiketten er gruppens navn skrevet ut; `aria-label` på radiogruppen sier det
          samme for skjermleseren, så teksten her er `aria-hidden` og ikke sagt to ganger. */}
      <div className="panel-tema-etikett" aria-hidden="true">
        <Ikon navn="contrast-outline" /> Fargepalett
      </div>
      <div className="panel-tema-valg" role="radiogroup" aria-label="Fargepalett">
        {VALG.map((v) => (
          <button
            key={v.verdi}
            type="button"
            role="radio"
            aria-checked={valg === v.verdi}
            className="panel-tema-knapp"
            onClick={() => {
              skrivValg(v.verdi);
              setValg(v.verdi);
            }}
          >
            {v.navn}
            {valg === v.verdi ? <Ikon navn="checkmark-outline" className="panel-tema-hake" /> : null}
          </button>
        ))}
      </div>
    </div>
  );
}
